import ajaxRequest from "../utils/ajaxRequest";
import showMessage from "../utils/showMessage";

export default async function (element, data) {
    window.addEventListener("open-remove-popup", function() {
        element.classList.add("visible");
    });

    window.addEventListener("close-remove-popup", function() {
        element.classList.remove("visible");
    });

    element.querySelectorAll(".button-close").forEach(item => {
        item.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent('close-remove-popup'));
        })
    })

    element.querySelector(".submit-button").addEventListener("click", async function() {
        element.classList.add("loading");
        const response = await ajaxRequest("/user_account/delete-account", []);
        element.classList.remove("loading");
        window.dispatchEvent(new CustomEvent('close-remove-popup'));
        
        if(response && response.status == '0') {
            showMessage(response.displayMsg, {
                onClose: () => {
                    window.location.href = "/";
                }
            });
        } else if (response && response.status == 3) {
            showMessage(response.displayMsg);
        }
    });
};